<ng-idle-modal [id]="modalId">
  <ng-idle-warning
    *ngIf="isIdlePopupOpen"
    [titleMessage]="titleMessage"
    [bodyMessage]="bodyMessage"
  ></ng-idle-warning>
</ng-idle-modal>
